import { Controller } from "@hotwired/stimulus"

// Import JIT library for capital structure charts
import "original_assets/Icicle/jit.js";

export default class extends Controller {
  connect() {
    // Initialize the capital structure chart when the controller connects
    const jsonValue = this.element.getAttribute('data-capital-structure-json-value')
    if (jsonValue) {
      try {
        const json = JSON.parse(jsonValue)
        this.loadCreditStructure(json)
      } catch (error) {
        console.error('Error parsing capital structure JSON:', error)
      }
    }
  }

  loadCreditStructure(json) {
    // Modern re-implementation of the credit structure functionality
    this.controls()
    
    // Create events object with proper references
    const eventsObj = {
      enable: true,
      onMouseEnter: function(node) {
        //add border and replot node
        node.setData('border', '#33dddd');
        this.icicle.fx.plotNode(node, this.icicle.canvas);
        this.icicle.labels.plotLabel(this.icicle.canvas, node, this.icicle.controller);
      }.bind(this),
      onMouseLeave: function(node) {
        node.removeData('border');
        this.icicle.fx.plot();
      }.bind(this),
      onClick: function(node) {
        if (node) {
          //hide tips and selections
          this.icicle.tips.hide();
          if(this.icicle.events.hovered)
            eventsObj.onMouseLeave(this.icicle.events.hovered);
          //perform the enter animation
          this.icicle.enter(node);
        }
      }.bind(this),
      onRightClick: function() {
        //hide tips and selections
        this.icicle.tips.hide();
        if(this.icicle.events.hovered)
          eventsObj.onMouseLeave(this.icicle.events.hovered);
        //perform the out animation
        this.icicle.out();
      }.bind(this)
    };

    // Initialize Icicle chart
    this.icicle = new $jit.Icicle({
      // id of the visualization container
      injectInto: 'infovis',
      // whether to add transition animations
      animate: this.animate,
      // nodes offset
      offset: 20,
      // whether to add cushion type nodes
      cushion: false,
      //show only three levels at a time
      constrained: true,
      levelsToShow: 2,
      // enable tips
      Tips: {
        enable: true,
        type: 'Native',
        // add positioning offsets
        offsetX: 20,
        offsetY: 20,
        // implement the onShow method to
        // add content to the tooltip when a node
        // is hovered
        onShow: (tip, node) => {
          // count children
          var count = 0;
          node.eachSubnode(() => {
            count++;
          });
          // add tooltip info
          tip.innerHTML = "<div class=\"flex flex-col gap-1 bg-neutral-100 dark:bg-neutral-900 p-2 rounded-lg\"><div class=\"text-xs text-neutral-600 \"><b>Name:</b> " + node.name
              + "</div><div class=\"text-xs text-neutral-600\">" + count + " Securities</div></div>";
        }
      },
      // Add events to nodes
      Events: eventsObj,
      // Add canvas label styling
      Label: {
        type: this.labelType // "Native" or "HTML"
      },
      // Add the name of the node in the corresponding label
      // This method is called once, on label creation and only for DOM and not
      // Native labels.
      onCreateLabel: (domElement, node) => {
        domElement.innerHTML = node.name;
        var style = domElement.style;
        style.fontSize = '0.9em';
        style.display = '';
        style.cursor = 'pointer';
        style.color = '#333';
        style.overflow = 'hidden';
      },
      // Change some label dom properties.
      // This method is called each time a label is plotted.
      onPlaceLabel: (domElement, node) => {
        var style = domElement.style,
            width = node.getData('width'),
            height = node.getData('height');
        if(width < 7 || height < 7) {
          style.display = 'none';
        } else {
          style.display = '';
          style.width = width + 'px';
          style.height = height + 'px';
        }
      }
    });
    
    // load data
    this.icicle.loadJSON(json);
    // compute positions and plot
    this.icicle.refresh();
  }

  controls() {
    // Initialize controls
    var jit = $jit;
    var gotoparent = jit.id('update');
    if (gotoparent) {
      jit.util.addEvent(gotoparent, 'click', () => {
        this.icicle.out();
      });
    }
  }

  // Initialize chart configuration
  get labelType() {
    var ua = navigator.userAgent,
        iStuff = ua.match(/iPhone/i) || ua.match(/iPad/i),
        typeOfCanvas = typeof HTMLCanvasElement,
        nativeCanvasSupport = (typeOfCanvas == 'object' || typeOfCanvas == 'function'),
        textSupport = nativeCanvasSupport 
          && (typeof document.createElement('canvas').getContext('2d').fillText == 'function');
    //I'm setting this based on the fact that ExCanvas provides text support for IE
    //and that as of today iPhone/iPad current text support is lame
    return (!nativeCanvasSupport || (textSupport && !iStuff))? 'Native' : 'HTML';
  }

  get animate() {
    var ua = navigator.userAgent,
        iStuff = ua.match(/iPhone/i) || ua.match(/iPad/i),
        typeOfCanvas = typeof HTMLCanvasElement,
        nativeCanvasSupport = (typeOfCanvas == 'object' || typeOfCanvas == 'function');
    return !(iStuff || !nativeCanvasSupport);
  }
} 
